<template>
<figure class="m-0">
	<!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
	<svg ref="svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="80 0 260 216" style="enable-background:new 0 0 410 216;" xml:space="preserve">
		<g>
			<path class="field-bg" d="M298.7,116.3c-0.5-2.5-1-5-1.7-7.5l-84.8,81.7c-0.6-0.5-1.2-0.9-1.9-1.2l5-4.8c-0.3-0.2-0.6-0.5-1-0.7
				l-0.1-0.1c-0.5-0.3-0.9-0.5-1.4-0.8l-0.3-0.1c-0.4-0.2-0.9-0.4-1.4-0.6c-0.1,0-0.2-0.1-0.3-0.1c-0.4-0.2-0.9-0.3-1.3-0.4
				c-0.2,0-0.4-0.1-0.6-0.1c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0-0.4-0.1-0.7-0.1c-0.4-0.1-0.7-0.1-1.1-0.1c-0.5,0-1.1-0.1-1.6-0.1l0,0
				c-0.5,0-1,0-1.5,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.3,0-0.6,0.1-1,0.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.3,0.1-0.7,0.2-1,0.2
				c-0.2,0.1-0.5,0.1-0.7,0.2c-0.3,0.1-0.7,0.2-1,0.4c-0.2,0.1-0.4,0.2-0.6,0.3c-0.3,0.1-0.7,0.3-1,0.5c-0.2,0.1-0.4,0.2-0.6,0.3
				c-0.3,0.2-0.7,0.4-1,0.6c-0.2,0.1-0.5,0.3-0.7,0.5l-0.1,0.1l5.3,5.1c-0.6,0.4-1.2,0.8-1.8,1.3l-86-82.8c-0.5,2.7-0.8,5.3-0.9,8.1
				c25.9,25,51.8,50.1,77.6,75.4c-0.9,2.1-1.4,4.4-1.4,6.7c0,9.5,8.1,17.2,18.1,17.2s18.1-7.7,18.1-17.2c0-2.3-0.5-4.6-1.4-6.7
				C247.1,166.5,272.1,140.7,298.7,116.3z"/>
			<path class="field-bg" d="M157.1,128.9l36.1-34.3c6.7,5.1,16,5.1,22.7,0l36.1,34.3c-5.1,5.9-5.4,14.7-0.6,20.9l45-43.4
				c-7-24.6-23.3-46.7-44.7-57.1c-13.6-6.6-29.1-10.1-44.9-10.4c-1.1,0-2.2,0-3.3,0l0,0c-16.3,0-33,2.6-46.1,10.3
				c-24.4,14.3-41,36-45.8,56.4l45.9,44.2C162.4,143.6,162.2,134.9,157.1,128.9z M259,137.4l-3.8,3.6l-3.8-3.6l3.8-3.6L259,137.4z
				M204.5,87.3l3.8,3.6l-3.8,3.6l-3.8-3.6L204.5,87.3z M150,137.4l3.8-3.6l3.8,3.6l-3.8,3.6L150,137.4z"/>
			<path class="field-bg" d="M187.3,138.7c0,9.5,7.7,17.2,17.2,17.2c9.5,0,17.2-7.7,17.2-17.2c0,0,0,0,0,0c0-9.5-7.7-17.2-17.2-17.2
				C195,121.5,187.3,129.2,187.3,138.7z"/>
		</g>
		<g class="player-position utl">
			<g class="player-position of">
				<g class="player-position lf">
					<g class="position">
						<circle id="Ellipse_471_2_" class="position" cx="108.9" cy="42.9" r="8.9"/>
						<path class="position" d="M121.2,38.1h2V46h4.1v1.7h-6.1V38.1z"/>
						<path class="position" d="M128.6,38.1h6.3v1.7h-4.3v2.3h3.9v1.7h-3.9v3.9h-2V38.1z"/>
					</g>
				</g>
				<g class="player-position cf">
					<g class="position">
						<circle id="Ellipse_471_1_" class="position" cx="203.9" cy="14.4" r="8.9"/>
						<path class="position" d="M222.2,13c-0.2-1-0.9-1.7-2.1-1.7c-1.5,0-2.4,1.1-2.4,3.1c0,2,1,3.1,2.4,3.1c1.1,0,1.9-0.6,2.1-1.6l2,0
							c-0.2,1.8-1.7,3.4-4.1,3.4c-2.5,0-4.4-1.8-4.4-4.9c0-3.1,1.9-4.9,4.4-4.9c2.2,0,3.9,1.3,4.1,3.5H222.2z"/>
						<path class="position" d="M225.7,9.6h6.3v1.7h-4.3v2.3h3.9v1.7h-3.9v3.9h-2V9.6z"/>
					</g>
				</g>
				<g class="player-position rf">
					<g class="position">
						<circle id="Ellipse_471_3_" class="position" cx="300.9" cy="42.9" r="8.9"/>
						<path class="position" d="M313.1,38.1h3.8c2.2,0,3.4,1.2,3.4,3.1c0,1.3-0.6,2.2-1.7,2.7l2,3.7h-2.2l-1.8-3.4h-1.5v3.4h-2V38.1z
							M316.5,42.7c1.2,0,1.7-0.5,1.7-1.4c0-0.9-0.6-1.5-1.7-1.5h-1.4v2.9H316.5z"/>
						<path class="position" d="M321.7,38.1h6.3v1.7h-4.3v2.3h3.9v1.7h-3.9v3.9h-2V38.1z"/>
					</g>
				</g>
			</g>
			<g class="player-position inf">
				<g class="player-position ss">
					<g class="position">
						<circle id="Ellipse_471_7_" class="position" cx="159.6" cy="77.7" r="8.9"/>
						<path class="position" d="M174.3,74.5c-1,0-1.5,0.5-1.5,1.1c0,0.7,0.7,1,1.5,1.2l0.9,0.2c1.7,0.4,2.9,1.2,2.9,2.8
							c0,1.7-1.4,2.9-3.7,2.9c-2.3,0-3.8-1.1-3.8-3.1h1.9c0.1,1,0.8,1.4,1.9,1.4c1,0,1.7-0.5,1.7-1.2c0-0.6-0.6-0.9-1.6-1.2l-1-0.3
							c-1.6-0.4-2.6-1.2-2.6-2.6c0-1.7,1.5-2.9,3.6-2.9c2.1,0,3.5,1.2,3.5,2.9h-1.9C175.9,74.9,175.3,74.5,174.3,74.5z"/>
						<path class="position" d="M182.9,74.5c-1,0-1.5,0.5-1.5,1.1c0,0.7,0.7,1,1.5,1.2l0.9,0.2c1.7,0.4,2.9,1.2,2.9,2.8
							c0,1.7-1.4,2.9-3.7,2.9c-2.3,0-3.8-1.1-3.8-3.1h1.9c0.1,1,0.8,1.4,1.9,1.4c1,0,1.7-0.5,1.7-1.2c0-0.6-0.6-0.9-1.6-1.2l-1-0.3
							c-1.6-0.4-2.6-1.2-2.6-2.6c0-1.7,1.5-2.9,3.6-2.9c2.1,0,3.5,1.2,3.5,2.9h-1.9C184.4,74.9,183.9,74.5,182.9,74.5z"/>
					</g>
				</g>
				<g class="player-position 2b">
					<g class="position">
						<circle id="Ellipse_471_8_" class="position" cx="237.6" cy="77.7" r="8.9"/>
						<path class="position" d="M249.4,81.1l3.4-3.1c0.9-0.8,1.3-1.4,1.3-2.1c0-0.8-0.6-1.4-1.5-1.4c-0.9,0-1.4,0.6-1.4,1.5h-1.9
							c0-1.9,1.4-3.1,3.4-3.1c2,0,3.4,1.2,3.4,2.8c0,1.1-0.5,2-2.5,3.8l-1.4,1.4v0.1h4v1.6h-6.8V81.1z"/>
						<path class="position" d="M257.7,73h3.8c2.1,0,3.2,1,3.2,2.4c0,1.1-0.7,1.8-1.7,2v0.1c1.1,0.1,2.1,0.9,2.1,2.3c0,1.5-1.1,2.6-3.3,2.6
							h-4.1V73z M261.2,77c0.8,0,1.4-0.5,1.4-1.2c0-0.7-0.5-1.1-1.4-1.1h-1.5V77H261.2z M261.3,80.9c1.1,0,1.6-0.5,1.6-1.2
							c0-0.8-0.6-1.3-1.6-1.3h-1.7v2.5H261.3z"/>
					</g>
				</g>
				<g class="player-position 3b">
					<g class="position">
						<circle id="Ellipse_471_4_" class="position" cx="150.1" cy="138.9" r="8.9"/>
						<path class="position" d="M160.3,140.9h2c0,0.7,0.7,1.2,1.6,1.2c0.9,0,1.6-0.5,1.6-1.3c0-0.8-0.7-1.3-1.7-1.3h-0.9V138h0.9
							c0.9,0,1.6-0.5,1.5-1.3c0-0.7-0.5-1.2-1.4-1.2c-0.8,0-1.5,0.5-1.5,1.2h-1.9c0-1.6,1.5-2.8,3.5-2.8c2,0,3.3,1.2,3.3,2.7
							c0,1.1-0.7,1.8-1.8,2v0.1c1.4,0.2,2.2,1,2.1,2.2c0,1.6-1.5,2.8-3.7,2.8C161.9,143.8,160.4,142.6,160.3,140.9z"/>
						<path class="position" d="M169.1,134.1h3.8c2.1,0,3.2,1,3.2,2.4c0,1.1-0.7,1.8-1.7,2v0.1c1.1,0.1,2.1,0.9,2.1,2.3
							c0,1.5-1.1,2.6-3.3,2.6h-4.1V134.1z M172.6,138.1c0.8,0,1.4-0.5,1.4-1.2c0-0.7-0.5-1.1-1.4-1.1h-1.5v2.4H172.6z M172.8,142
							c1.1,0,1.6-0.5,1.6-1.2c0-0.8-0.6-1.3-1.6-1.3h-1.7v2.5H172.8z"/>
					</g>
				</g>
				<g class="player-position 1b">
					<g class="position">
						<circle id="Ellipse_471_6_" class="position" cx="258.7" cy="138.9" r="8.9"/>
						<path class="position" d="M273.8,143.6h-2v-7.1h-0.1c-0.2,0.3-0.9,0.7-1.9,0.7v-1.6c1.2,0,2-1,2.1-1.6h2V143.6z"/>
						<path class="position" d="M276.1,134.1h3.8c2.1,0,3.2,1,3.2,2.4c0,1.1-0.7,1.8-1.7,2v0.1c1.1,0.1,2.1,0.9,2.1,2.3
							c0,1.5-1.1,2.6-3.3,2.6h-4.1V134.1z M279.6,138.1c0.8,0,1.4-0.5,1.4-1.2c0-0.7-0.5-1.1-1.4-1.1h-1.5v2.4H279.6z M279.8,142
							c1.1,0,1.6-0.5,1.6-1.2c0-0.8-0.6-1.3-1.6-1.3h-1.7v2.5H279.8z"/>
					</g>
				</g>
			</g>
		</g>
		<g class="player-position p">
			<g class="position">
			<circle id="Ellipse_471_5_" class="position" cx="203.9" cy="138.9" r="8.9"/>
				<path class="position" d="M215,134.4h3.5c2,0,3.2,1.2,3.2,3c0,1.8-1.2,3-3.2,3h-1.6v2.9H215V134.4z M218.1,138.9c1.1,0,1.6-0.6,1.6-1.5
					c0-0.9-0.5-1.5-1.6-1.5h-1.3v3H218.1z"/>
			</g>
		</g>
		<g class="player-position c">
			<g class="position">
				<circle id="Ellipse_469_1_" class="position" cx="204.9" cy="199.9" r="8.9"/>
				<path class="position" d="M221.7,198.5c-0.2-1-0.9-1.7-2.1-1.7c-1.5,0-2.4,1.1-2.4,3.1c0,2,1,3.1,2.4,3.1c1.1,0,1.9-0.6,2.1-1.6l2,0
					c-0.2,1.8-1.7,3.4-4.1,3.4c-2.5,0-4.4-1.8-4.4-4.9c0-3.1,1.9-4.9,4.4-4.9c2.2,0,3.9,1.3,4.1,3.5H221.7z"/>
			</g>
		</g>
	</svg>
</figure>

</template>

<script>
import positionsLogic from './AthletePositionsLogic';
export default {
    mixins: [ positionsLogic ]
}
</script>

<style>

</style>